import { type ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';
import { Image } from '@chakra-ui/react';

import { ChallengeMethod } from '__generated__/GQL';
import mail from 'assets/brand/mail.png';
import handWithPhoneNotif from 'assets/images/strongAuthentication/handWithPhoneNotif.svg';

export type ComponentMethodInfo = {
  image: ReactElement;
  title: ReactElement;
  description: ReactElement;
};

export const getMethodComponentInfo = (
  method: ChallengeMethod,
): ComponentMethodInfo => {
  switch (method) {
    case ChallengeMethod.ConnectedDevices:
      return {
        description: (
          <FormattedMessage id="authentication.challenge.verifying_connected_devices_description" />
        ),
        image: <Image marginX="auto" src={handWithPhoneNotif} width="416px" />,
        title: (
          <FormattedMessage id="authentication.challenge.verifying_connected_devices_title" />
        ),
      };

    case ChallengeMethod.Email:
      return {
        description: (
          <FormattedMessage id="authentication.challenge.verifying_email_description" />
        ),
        image: <Image marginX="auto" src={mail} width="200px" />,
        title: (
          <FormattedMessage id="authentication.challenge.verifying_email_title" />
        ),
      };
    case ChallengeMethod.Mda:
    default:
      return {
        description: (
          <FormattedMessage id="authentication.challenge.verifying_mda_description" />
        ),
        image: <Image marginX="auto" src={handWithPhoneNotif} width="416px" />,
        title: (
          <FormattedMessage id="authentication.challenge.verifying_mda_title" />
        ),
      };
  }
};
